import { ChangeEvent, useEffect } from "react";
import { useRegistrationContext } from "../../context/registrationContext";
import { useTimeParser } from "../../hooks/useTimeParser";
import StepTwoView from "./StepTwoView";

type TProps = {
    handleSendOtpCall: () => Promise<boolean>;
    handlePostFalseDryRun: () => void;
    inProgress: boolean;
};

export default function StepTwoContainer({
    handleSendOtpCall,
    handlePostFalseDryRun,
    inProgress,
}: TProps) {
    const { state, dispatch } = useRegistrationContext();
    const { secondCoolDown, reset } = useTimeParser();

    //If there were an error and then user fixed the info
    //After sending the data the error will cleared here
    useEffect(() => {
        dispatch({ type: "clearError" });
    }, []);

    const handleOtpChange = (event: ChangeEvent<HTMLInputElement>) => {
        dispatch({ type: "setOtpCode", payload: event.target.value });
    };

    const handleButtonClick = () => {
        handlePostFalseDryRun();
    };

    const handleResendButton = async () => {
        const isOk = await handleSendOtpCall();
        if (isOk) reset();
    };

    return (
        <StepTwoView
            state={state}
            // State handlers
            handleResendButton={handleResendButton}
            handleButtonClick={handleButtonClick}
            handleOtpChange={handleOtpChange}
            inProgress={inProgress}
            // minuteCoolDown={String(minuteCoolDown)}
            secondCoolDown={secondCoolDown}
        />
    );
}
